var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeniusTitle = function SvgGeniusTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#geniusTitle_svg__a)",
    d: "M63.549 15.896c-3.96 0-4.945-1.608-5.089-3.528l3.768-.744c.169 1.08.697 1.488 1.68 1.488.745 0 1.176-.192 1.248-.6.096-.48-.12-.912-1.944-1.32-3.072-.744-3.936-2.112-3.552-4.224.385-2.112 2.16-3.264 5.449-3.264 3.552 0 4.392 1.536 4.68 3.288l-3.745.744c-.096-.936-.383-1.32-1.343-1.32-.744 0-1.152.192-1.224.6-.096.504.048.888 1.848 1.32 3.48.816 4.055 2.376 3.72 4.248-.385 2.112-2.064 3.312-5.497 3.312"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#geniusTitle_svg__b)",
    d: "m52.624 15.536.552-3.12h-.264c-1.08 2.376-2.568 3.48-4.2 3.48-1.992 0-2.88-1.56-2.4-4.176l1.344-7.656h4.08L50.56 10.76c-.168.936.192 1.464.984 1.464.96 0 1.68-.768 1.872-1.896l1.104-6.264h4.08l-2.016 11.472z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#geniusTitle_svg__c)",
    d: "M45.807 4.064 43.79 15.536h-4.08l2.017-11.472zm.695-3.936-.48 2.712h-4.08l.48-2.712z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#geniusTitle_svg__d)",
    d: "m32.937 4.064-.552 3.096h.264c1.08-2.328 2.568-3.456 4.224-3.456 1.944 0 2.856 1.512 2.4 4.176l-1.368 7.656h-4.08l1.2-6.72c.12-.888-.216-1.44-1.008-1.44-.96 0-1.68.792-1.872 1.872l-1.104 6.288h-4.08l2.016-11.472z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#geniusTitle_svg__e)",
    d: "M20.295 15.896c-3.432 0-5.76-2.088-4.944-6.624.6-3.528 2.952-5.568 6.504-5.568 3.888 0 5.256 2.448 4.728 5.592-.096.456-.168.768-.288 1.224H19.12c-.096 1.56.408 2.136 1.632 2.136 1.152 0 1.584-.528 1.896-1.176l3.288 1.008c-.816 1.824-2.256 3.408-5.64 3.408m-.912-6.936h3.528c.312-1.56-.192-2.256-1.368-2.256-1.128 0-1.752.6-2.16 2.256"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#geniusTitle_svg__f)",
    d: "M4.296 15.8c-2.904 0-4.992-2.64-4.08-7.872C1.056 3.416 3.744.8 8.256.8c4.32 0 5.904 1.92 6.048 4.824l-4.248.576C9.96 5.168 9.48 4.52 7.92 4.52c-2.04 0-3 1.344-3.456 3.768-.456 2.568.096 4.032 2.208 4.032s2.784-.984 2.976-1.968H6.864L7.392 7.4h6.816l-1.44 8.136H8.856l.528-3.072h-.336c-.936 1.92-2.424 3.336-4.752 3.336m5.352-5.448.024.048v-.048z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "geniusTitle_svg__a",
    x1: 94.837,
    x2: -21.498,
    y1: 0.895,
    y2: 15.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "geniusTitle_svg__b",
    x1: 94.837,
    x2: -21.498,
    y1: 0.895,
    y2: 15.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "geniusTitle_svg__c",
    x1: 94.837,
    x2: -21.498,
    y1: 0.895,
    y2: 15.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "geniusTitle_svg__d",
    x1: 94.837,
    x2: -21.497,
    y1: 0.895,
    y2: 15.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "geniusTitle_svg__e",
    x1: 94.837,
    x2: -21.497,
    y1: 0.895,
    y2: 15.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "geniusTitle_svg__f",
    x1: 94.837,
    x2: -21.497,
    y1: 0.895,
    y2: 15.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })))));
};
export default SvgGeniusTitle;